export const setFunds = (state, funds) => {
  state.funds = funds
  state.loaded = true
}

export const setLoading = (state, value) => {
  state.loading = value
}
